import AppClient from "../utils/http-client/app-client"
import {
  RegisterAdviceBody,
  RegisterBody,
  ValidateRegisterRequestBody,
} from "../utils/type/register-type"
import { ApiResponse } from "../utils/type/api-response.type"

const url = "/api/v1/registration"

export const registerAdvice = (
  registerBody: RegisterAdviceBody
): ApiResponse<string> => {
  return AppClient.post(`${url}/advice`, {
    nationalId: registerBody.nationalId,
    dateOfBirth: registerBody.dateOfBirth,
    isResend: registerBody.isResend,
    lastKey: registerBody.lastKey,
  })
}

export const register = (registerBody: RegisterBody): ApiResponse<any> => {
  return AppClient.post(url, {
    nationalId: registerBody.nationalId,
    dateOfBirth: registerBody.dateOfBirth,
    otp: registerBody.otp,
  })
}

export const validateRegisterCredential = (
  requestBody: ValidateRegisterRequestBody
): ApiResponse<Array<boolean>> => {
  return AppClient.post(`${url}/check-registration`, {
    nationalId: requestBody.nationalId,
    dateOfBirth: requestBody.dateOfBirth,
    lastKey: requestBody.lastKey,
    inputCode: requestBody.inputCode,
  })
}
